export default __webpack_public_path__ + "static/media/sodium-carbonate.82d0cf88.jpg";